/* global Lang */

import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import HeroAvatar from '../../../game/components/Hero/Avatar';
import Tooltip from '../Tooltip';
import { unlerp } from '../../../common/utilities/math';

const Hero = styled(HeroAvatar)`
  position: absolute;
  display: block;
  top: 50%;
  width: 30px;
  height: 30px;
  margin: -15px;

  left: ${p => Math.round(unlerp(...p.range, p.score) * 100)}%;
  transition: left 0.3s;
  overflow: visible;

  & > div:first-child {
    width: 100%;
    height: 100%;
  }

  ${Tooltip} {
    bottom: 100%;
    left: 56%;
    transform: translateX(-50%);
    pointer-events: none;

    /* because tooltips in popovers be broke */
    .arrow:before {
      border-top-color: black;
    }
  }

  &:hover {
    z-index: 2;

    ${Tooltip} {
      opacity: 1;
    }
  }
`;

const DomainHeroScores = ({ className, domains }) => {
  const relativeRange = useMemo(() => {
    let min = 0;
    let max = 0;
    for (let i = 0; i < domains.length; i += 1) {
      const domain = domains[i];
      if (domain.hero) {
        if (domain.score < min) {
          min = domain.score;
        } else if (domain.score > max) {
          max = domain.score;
        }
      }
    }

    return [max, min];
  }, [domains]);
  const absoluteRange = [6, -6];
  const [range, setRange] = useState(absoluteRange);
  return (
    <div
      className={className}
      onMouseOver={() => setRange(relativeRange)}
      onFocus={() => setRange(relativeRange)}
      onMouseOut={() => setRange(absoluteRange)}
      onBlur={() => setRange(absoluteRange)}
    >
      <div className="alert alert-secondary m-0">
        {domains.map(
          ({ id, score, hero }) => hero && (
          <Hero key={id} score={score} range={range} {...hero} unlocked>
            <Tooltip>{`${hero.name} (${Math.round(score * 100) / 100})`}</Tooltip>
          </Hero>
          ),
        )}
      </div>
      <div className="d-flex justify-content-between">
        <span>{Lang.get('messages.dashboard.activities.most')}</span>
        <span>{Lang.get('messages.dashboard.activities.least')}</span>
      </div>
    </div>
  );
};

export default styled(DomainHeroScores)``;
